import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

// "I have forgotten my password." No sign-in, no token, nothing known about who
// is looking at it.
//
// The one thing this screen must never do is tell anybody whether an address has
// an account. So there is exactly ONE success message, it is shown for a real
// address and an unknown one alike, and it says out loud that it works that way
// — which is kinder than leaving a coach wondering whether they typed their
// address wrong.
//
// All the wording on this page was written in-house to match the voice already
// on the portal's other screens. It has NOT been shown to anyone at the club
// and the club has not approved it. Daniel can change any of it.
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setDone('');
    if (busy) return;              // guards a double tap on a phone
    setBusy(true);
    try {
      const res = await api.post('/api/auth/forgot-password', { email });
      setDone(res.data.message);
    } catch (err) {
      // Three things can land here and all three are honest to show:
      //   503  email is not switched on yet (the state the portal ships in)
      //   429  too many requests, from this connection or for this address
      //   500  something broke, and the server says only "Server error"
      setError(err.response?.data?.error || 'That could not be sent. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>City of Preston Basketball</h1>
        <p className="muted">Coach portal</p>

        {/* Multi-paragraph wording, so the whitespace in the sentence the server
            sent has to survive. pre-line is what keeps the blank lines. */}
        {error && <div className="error-msg prewrap">{error}</div>}
        {done && <div className="success-msg prewrap">{done}</div>}

        {!done && (
          <>
            <h2>Forgotten your password?</h2>
            <p className="muted" style={{ textAlign: 'left' }}>
              Type the email address you sign in with and we will send you a link to set a new password.
            </p>
            <form onSubmit={submit}>
              <div className="form-row">
                <label htmlFor="forgot-email">Email</label>
                <input
                  id="forgot-email"
                  name="email"
                  type="email"
                  autoComplete="username"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setError(''); }}
                  required
                  autoFocus
                />
              </div>
              <button className="btn" type="submit" disabled={busy} style={{ width: '100%' }}>
                {busy ? 'Sending…' : 'Send me a link'}
              </button>
            </form>
          </>
        )}

        <p className="muted" style={{ textAlign: 'center', marginBottom: 0, marginTop: '1rem' }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
